export default import.meta.ROLLUP_FILE_URL_K1daVVNYU_lXF$FdA5v55g;